import { AnnotationTemplateSelectField } from '@/graphql/codegen/graphql';
import { AnnotationDraft } from '@/stores/explore';

export const getAnnotationColor = (annotationDraft: AnnotationDraft | null) => {
  if (!annotationDraft) return;
  const templateField = annotationDraft?.template?.fields?.find(
    item => item?.name === annotationDraft?.template?.colorFromField,
  );
  const annotationField = annotationDraft?.fields?.find(
    field => field?.fieldId === templateField?.id,
  );
  if (!templateField) return annotationDraft?.color?.toUpperCase();
  else {
    const options = (templateField as AnnotationTemplateSelectField).options;
    const selected = options?.find(item => item?.id === annotationField?.optionId);
    return selected?.color?.toUpperCase() ?? '#FFFFFF';
  }
};
